module.exports = {
      id: "newsletterimg-usage",
      viewBox: "0 0 125 112",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#newsletterimg",
      toString: function () {
        return this.url;
      }
    }